import { Link } from 'react-router-dom';

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b px-4 py-3 flex items-center gap-3 sticky top-0 z-10">
        <Link to="/login" className="text-green-600 font-medium">← Retour</Link>
        <h1 className="font-bold text-gray-800">Mentions Légales</h1>
      </div>
      <div className="max-w-2xl mx-auto p-6 space-y-4 text-gray-700">
        <div className="text-center py-4">
          <div className="text-4xl mb-2">📋</div>
          <h2 className="text-2xl font-bold text-green-700">Mentions Légales</h2>
          <p className="text-xs text-gray-400 mt-1">Conformément aux lois en vigueur</p>
        </div>

        {[
          {
            title: "Éditeur de la plateforme",
            items: [
              "Nom : M. Sassou-Messan",
              "Plateforme : SantéTogo",
              "Email : support@secury.ovh",
              "Pays : Togo",
            ]
          },
          {
            title: "Hébergement",
            items: [
              "Hébergeur : OVHcloud",
              "Adresse : 2 rue Kellermann, 59100 Roubaix, France",
              "Site : www.ovhcloud.com",
              "Serveur : VPS Ubuntu 22.04",
            ]
          },
          {
            title: "Propriété intellectuelle",
            items: [
              "L'ensemble du contenu de la plateforme SantéTogo (textes, logos, interface, code source) est la propriété exclusive de M. Sassou-Messan.",
              "Toute reproduction, distribution ou utilisation sans autorisation écrite préalable est strictement interdite.",
            ]
          },
          {
            title: "Protection des données personnelles",
            items: [
              "Responsable du traitement : M. Sassou-Messan",
              "Les données sont collectées pour la gestion des rendez-vous médicaux uniquement.",
              "Aucune donnée n'est cédée à des tiers à des fins commerciales.",
              "Droit d'accès et de suppression : support@secury.ovh",
              "Durée de conservation : 5 ans à compter du dernier rendez-vous.",
            ]
          },
          {
            title: "Cookies",
            items: [
              "La plateforme utilise uniquement des cookies techniques nécessaires au fonctionnement (authentification, session).",
              "Aucun cookie publicitaire ou de tracking tiers n'est utilisé.",
            ]
          },
          {
            title: "Limitation de responsabilité",
            items: [
              "SantéTogo est une plateforme d'intermédiation et n'exerce pas la médecine.",
              "Les consultations et diagnostics relèvent de la seule responsabilité des médecins inscrits.",
              "L'éditeur ne peut être tenu responsable des interruptions de service ou pertes de données.",
            ]
          },
          {
            title: "Droit applicable",
            items: [
              "La plateforme est soumise au droit togolais.",
              "Juridiction compétente : Tribunaux de Lomé, Togo.",
            ]
          },
        ].map((section, i) => (
          <div key={i} className="card">
            <h3 className="font-bold text-green-700 mb-2">{section.title}</h3>
            <ul className="space-y-1">
              {section.items.map((item, j) => (
                <li key={j} className="text-sm leading-relaxed flex gap-2">
                  <span className="text-green-500 flex-shrink-0">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="text-center text-xs text-gray-400 pb-6">
          © 2026 SantéTogo — support@secury.ovh
        </div>
      </div>
    </div>
  );
}
